import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import Context from '../context'

const styles ={
    li: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '.5rem 1rem',
        border: '1px solid #ccc',
        borderRadius: '4px',
        marginBottom: '.5rem'
    },
    input: {
        marginRight: '1rem'
    }
}


function MangaItem({ manga, ind, onCheckBox }) {
    const { removeManga } = useContext(Context)
    const classes =[]
    if (manga.selected) {
        classes.push('done')
    }
    return(
        <li style={styles.li}> 
            <span className={classes.join(' ')}>
                <input 
                    style={styles.input} 
                    type="checkbox" 
                    checked={manga.selected}
                    onChange={() => onCheckBox(manga.mal_id)} 
                />
                <strong>{ ind+1 } </strong>
                <img src={manga.image_url} alt=""/>
                &nbsp;
                { manga.selected } : { manga.name } : { manga.role }
                <p><a href={manga.url}>Details...</a></p>
            </span>
            <button 
                className='rm'
                // onClick={() => removeManga(manga.mal_id)}  // 1й способ так чтобы функция сразу не вызывалась, ниже второй
                onClick={removeManga.bind(null, manga.mal_id)}
            >
                &times;
            </button>
        </li>
    )
}

MangaItem.propTypes = {
    manga: PropTypes.object.isRequired,
    ind: PropTypes.number,
    onCheckBox: PropTypes.func.isRequired
}

export default MangaItem